import { Color, Spacing } from '@persona-id/design-tokens';
import { css } from 'styled-components';

export const arrowStyles = css`
  content: '';
  position: absolute;
  right: ${Spacing[4]};
  top: 50%;

  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid ${Color.CoreSlate800};
  transform: translateY(-50%);
`;
